import Faq from '@di-shared/features/faq/Faq';

function FaqPage() {
  return <Faq />;
}

export default FaqPage;
